import React, { useState, useEffect } from "react";
import dynamic from "next/dynamic";
import Animation1 from "../../public/Animation/contract.json";
import Animation2 from "../../public/Animation/Idea.json";
import Animation3 from "../../public/Animation/Marking.json";
const Player = dynamic(() => import("@lottiefiles/react-lottie-player").then((mod) => mod.Player), { ssr: false });

const items = [
  {
    title: "Understand the Complete NEET UG Journey",
    animation: Animation3,
    desc: `NEET UG is the entrance exam for MBBS, BDS, AYUSH and other medical courses in India. From exam preparation to result, rank analysis, counselling registration, choice filling and seat allotment, every step needs proper planning to secure the best possible college.`,
  },
  {
    title: "Counselling Authorities, Quotas & Eligibility",
    animation: Animation2,
    desc: `NEET UG counselling is conducted through MCC for All India Quota, deemed universities, central universities and other national seats, while state authorities conduct counselling for state quota seats. Your eligibility depends on rank, category, domicile, documents and counselling rules.`,
  },
  {
    title: "Smart Choice Filling & Seat Allotment Strategy",
    animation: Animation1,
    desc: `After NEET UG results, your final admission depends on how smartly you fill choices across MCC and state counselling rounds. Correct college preference, cut-off analysis, fee, bond, stipend and seat matrix comparison can improve your chances of getting the right MBBS/BDS/AYUSH seat.`,
  },
];

export default function Overview() {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => { setIsClient(true); }, []);

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ">
      <div className="text-center mb-10">
        <h2 className="text-2xl sm:text-3xl font-bold">NEET UG – <span className="text-[#ff9245]">Overview</span></h2>
        <p className="text-sm sm:text-lg text-gray-500 mt-2">Everything you need to know about NEET UG counselling and how it shapes your medical career.</p>
      </div>

      <div className="space-y-16">
        {items.map((it, idx) => {
          const titleId = `overview-title-${idx}`;
          return (
            <article key={idx} aria-labelledby={titleId} className="flex flex-col lg:flex-row gap-8 items-center md:items-center lg:items-start">
              <div className="flex-shrink-0 flex items-center justify-center lg:w-40">
                <div className="flex items-center justify-center w-36 h-36 rounded-2xl ">
                  {isClient && (
                    <Player autoplay loop src={it.animation} style={{ width: "140px", height: "140px" }} aria-label={`${it.title} animation`} role="img" />
                  )}
                  {!isClient && <div className="w-24 h-24 bg-orange-200 rounded-full animate-pulse"></div>}
                </div>
              </div>

              <div className="flex-1 text-center lg:!text-left">
                <h3 id={titleId} className="text-lg sm:text-2xl font-bold text-gray-900 mb-4">{it.title}</h3>
                <p className="leading-relaxed text-gray-600 text-md sm:text-base mb-4">{it.desc}</p>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
